import { NgFor, NgIf } from "@angular/common";
import { Component } from "@angular/core";
import { FormlyModule } from "@ngx-formly/core";
import { PrimeTemplate } from "primeng-v17/api";
import { FieldsetModule } from "primeng-v17/fieldset";
import { TooltipModule } from "primeng-v17/tooltip";
import { FormElementMapModule } from "../../shared/from-element-map/form-element-map.module";
import { TestIdDirective } from "../../shared/test-id/test-id.directive";
import { NewUiFormlyCompetenciesComponent } from "./new-ui-formly-competencies.component";

/**
 * Renders competencies of the candidate of a type declared via {@link FormlyFieldConfig.key}.
 */
@Component({
  selector: "app-formly-competencies",
  templateUrl: "./formly-competencies.component.html",
  imports: [
    FormElementMapModule,
    NgFor,
    FieldsetModule,
    PrimeTemplate,
    NgIf,
    TooltipModule,
    TestIdDirective,
    FormlyModule,
  ],
})
export class FormlyCompetenciesComponent extends NewUiFormlyCompetenciesComponent {}
